import qs from "qs";
export default {
  data() {
    return {


    };
  },
  methods: {

    // 路由跳转
    push(param, type) {
      if (param && !type) {
        this.$router.push(param);
      }
      if (type == "open") {
     
        window.open(`${window.location.origin}${window.location.pathname}` + "#" + param.path + "?" + qs.stringify(param.query));
      }
    },


    // 返回
    back(param) {
      if (param && !param.target) {
        this.$router.replace(param);
      } else {
        this.$router.back(); //返回上一层
      }
    },
  },
};
